export type ThemeMode = 'light' | 'dark';

export interface ThemeState {
  theme: ThemeMode;
}

export const initialState: ThemeState = {
  theme: 'dark',
};

export type ThemeAction =
  | { type: 'TOGGLE_THEME' }
  | { type: 'SET_THEME'; payload: ThemeMode };

export const themeReducer = (state: ThemeState, action: ThemeAction): ThemeState => {
  switch (action.type) {
    case 'TOGGLE_THEME':
      // console.log('TOGGLE_THEME current state:', state); // Keep for debugging if needed
      return {
        ...state,
        theme: state.theme === 'light' ? 'dark' : 'light',
      };

    case 'SET_THEME':
      // console.log('SET_THEME payload:', action.payload); // Keep for debugging if needed
      return {
        ...state,
        theme: action.payload,
      };
    default:
      return {
        ...state,
        // It's good practice to ensure all paths return a valid state.
        // In this case, returning the current state for an unknown action type is fine.
      };
  }
};
